export class HorsParcourCertificate {
  constructor(
    public name: string,
    public shortname: string,
    public fullname: string,
    public displayname: string,
    public startDate: Date,
    public endDate: Date,
    public urlCertificat: string,
    public plateforme: string,
    public description: string,
    public urlImage?: string,
    public category?: number,
    public externalId?: string,
    public cohort?: string,
    public createdBy?: string,
    public certificatCode?: string, // 👈 AJOUTE CE PARAMÈTRE, optionnel avec ?
  ) {}
}
